import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./root.css";

import Modal, { ModalProvider } from "./context/Modal";
import Notifications, { NotificationsProvider } from "./context/Notifications";

import { StripeScope } from "./stripe/stripeComponents";
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <StripeScope>
      <NotificationsProvider>
        <ModalProvider>
          <App />
          <Modal />
          <Notifications />
        </ModalProvider>
      </NotificationsProvider>
    </StripeScope>
  </React.StrictMode>,
  document.getElementById("root")
);
